import { supabase } from "@/integrations/supabase/client";
import { setLotteryBasePrices, type LotterySlug } from "./pool-math";

let loaded = false;
let inflight: Promise<void> | null = null;

/**
 * Carrega os preços-base configurados pelo Painel Admin
 * (app_settings.lottery_prices) e atualiza a tabela usada por `ticketPrice`.
 * Idempotente: só faz a chamada de rede uma vez por sessão.
 */
export function loadLotteryPrices(): Promise<void> {
  if (loaded) return Promise.resolve();
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data } = await supabase
        .from("app_settings")
        .select("value")
        .eq("key", "lottery_prices")
        .maybeSingle();
      const raw = (data?.value ?? null) as Partial<Record<LotterySlug, number | string>> | null;
      if (raw && typeof raw === "object") {
        const parsed: Partial<Record<LotterySlug, number>> = {};
        (Object.keys(raw) as LotterySlug[]).forEach((slug) => {
          const v = raw[slug];
          const n = typeof v === "number" ? v : Number(String(v).replace(",", "."));
          if (Number.isFinite(n)) parsed[slug] = n;
        });
        setLotteryBasePrices(parsed);
      }
      loaded = true;
    } catch {
      // fallback silencioso para BASE_PRICE hardcoded
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}